/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectsCreateMutationRequest, ProjectsCreateMutationResponse } from "../models/ProjectsCreate";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { projectsCreate } from "../axios/projectsCreate";
import { useMutation } from "@tanstack/react-query";

export const projectsCreateMutationKey = () => ["video-editor-api", { url: '/projects' }] as const

export type ProjectsCreateMutationKey = ReturnType<typeof projectsCreateMutationKey>

/**
 * @summary Create a project from a source
 * {@link /projects}
 */
export function useProjectsCreate<TContext>(options: 
{
  mutation?: UseMutationOptions<ProjectsCreateMutationResponse, ResponseErrorConfig<Error>, {data: ProjectsCreateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ProjectsCreateMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? projectsCreateMutationKey()

  return useMutation<ProjectsCreateMutationResponse, ResponseErrorConfig<Error>, {data: ProjectsCreateMutationRequest}, TContext>({
    mutationFn: async({ data }) => {
      return projectsCreate(data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}